//angular imports
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

//local imports
import {
  CatalogDashboardComponent,
  DepartmentPropertyComponent,
  DetailsMainComponent,
  ListMainComponent,
  ProgramPropertyComponent,
  ProjectPropertyComponent,
  RoomContentPropertyComponent,
  RoomPropertyComponent,
} from "./pages";

export const routes: Routes = [
  {
    path: "",
    component: CatalogDashboardComponent,
    children: [
      {
        path: "",
        component: ListMainComponent,
      },
      {
        path: "",
        component: DetailsMainComponent,
        children: [
          { path: "room/:id", component: RoomPropertyComponent },
          { path: "department/:id", component: DepartmentPropertyComponent },
          { path: "project/:id", component: ProjectPropertyComponent },
          { path: "program/:id", component: ProgramPropertyComponent },
          { path: "room-content/:id", component: RoomContentPropertyComponent },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CatalogRoutingModule {}
